import { PdpCatalogFulfillmentType, PdpDeliveryType } from '../../graphql/select-option_types.2';

/**
 * 벤더플렉스는 직진배송으로 파싱
 * null인 경우 일반배송으로 파싱
 */
export const parseShippingType = (shipping_type: PdpDeliveryType | PdpCatalogFulfillmentType | null) => {
  switch (shipping_type) {
    case PdpDeliveryType.ZIGZIN:
    case PdpDeliveryType.VENDOR_FLEX:
    case PdpCatalogFulfillmentType.ZIGZIN:
    case PdpCatalogFulfillmentType.VENDOR_FLEX:
      return PdpDeliveryType.ZIGZIN;
    default:
      return PdpDeliveryType.GENERAL;
  }
};
